(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tracking-progress", [], factory);
	else if(typeof exports === 'object')
		exports["tracking-progress"] = factory();
	else
		root["tracking-progress"] = factory();
})(self, function() {
return 